

const SellApmc = () => {

  return (
    <>
    <div className="page-wrapper">
        <div className="w-100 d-flex flex-column justify-content-end px-5 ">
            <h2 className="py-3">Proposal for permission for selling land </h2>
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>
                    <div id='head' className='d-flex w-100 rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                    </div>
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                        <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                            <p className='p-2'>
                               જમીન/મિલકત વેચાણ માટે બજાર સમિતિની સાધારણ સભા/ ખાસ સાધારણ સભાની બેઠકના એજન્ડાની પ્રમાણિત નકલ. (Certified copy of the agenda of the general/special general meeting of the Market Committee for the sale of land/property.)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                            <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
    
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિની સાધારણ સભા/ખાસ સાધારણ સભાના ઠરાવથી આ બાબત નિર્ણય કરેલી હોવી જોઈએ. આ ઠરાવની પ્રમાણિત નકલ. આ અંગે કોઇનો વાંધો હોય તો તેની નકલ (બેઠકમાં રજૂ કર્યો હોય તે સિવાય પણ). (The matter must be decided through a resolution of the general/special meeting of the Market Committee. Certified copy of the resolution. If there is any objection, attach a copy of it—even if it was not raised in the meeting.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>03.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            વેચાણ કરકા સૂચિત જમીન / મકાનના સ્થળ સહિતની વિગત. ( Details of the proposed land/house to be sold, including the location.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>04.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            જમીન બજાર સમિતિને વેચવાની જરૂરિયાત છે તે અંગેનુ જસ્ટીફિકેશન તેમજ આવા વેચાણથી બજાર સમિતિને થનાર લાભની વિગતો તથા ઉપજનાર રકમના ઉપયોગ બાબતના આયોજનની વિગત. (Justification for the need to sell the land by the Market Committee, expected benefits from such sale, and the planning for utilization of the generated funds.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>05.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            જે જમીન/મિલકત બજાર સમિતિ વેચી રહી છે તે જમીન/મિલકત બજાર સમિતિએ કોની પાસેથી ખરીદી હતી? કેટલી કિંમતમાં, કેટલા સમય પહેલા ખરીદાઈ હતી? તેની વિગત તથા આધાર. (From whom was the land/property being sold by the Market Committee purchased? At what price, and how long ago? Provide full details and supporting documents.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>06.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           બજાર સમિતિ દ્વારા સ્થાવર મિલકત નિકાલ માટે લીધેલ નિર્ણય પૈકી જમીન/મકાનની માલિકી હકના નમૂના-૬, ૮-અ, ૭-૧૨ના છેવટના ઉતારાની નકલ તેમજ સીટી સર્વે કચેરીમાંથી પ્રોપર્ટી કાર્ડની ખરી નકલ રજૂ કરવાની રહેશે. (For the sale of immovable property, submit copies of ownership documents—Form 6, 8A, and 7/12—as well as the official property card from the City Survey Office.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>07.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિ જે જમીનનું વેચાણ કરી રહી છે તેનું સરકાર માન્ય પેનલ એડવોકેટ મારફત ટાઇટલ ક્લીયરન્સ સર્ટીફીકેટ અને સર્ચ રિપોર્ટની વિગત. (Title clearance certificate and search report for the land being sold, issued by a government-approved panel advocate.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>08.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            સરકાર માન્ય વેલ્યુઅર પાસેથી જમીન/મકાનનો લેઆઉટ પ્લાન (નકશો) અને વેલ્યુએશન રિપોર્ટ. (Layout plan (map) and valuation report of the land/property from a government-approved valuer.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>09.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                          સરકારશ્રીની જોગવાઈ મુજબ તે જમીન/મિલકતની સરકાર માન્ય જંત્રીની વિગત. (Government-approved Jantri rate details of the land/property as per official provisions.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>10.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-start'>
                        <p className='p-2'>
                           સરકારશ્રીની જોગવાઈ મુજબ તે જમીન/મિલકતની સરકાર માન્ય જંત્રીની વિગત. (Certificate from the Market Committee stating that the land/property to be sold is not under any (revenue/civil) court case or dispute.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>11.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                          બજાર સમિતિના છેલ્લા ત્રણ વર્ષના આવક-જાવકના પત્રક, મહેકમ ખર્ચના પત્રક, તથા પાકા સરવૈયા (ઓડીટેડ) કાયમી ભંડોળના પત્રક રજૂ કરવા. (Submit the Market Committee’s income-expenditure statements, administrative expense sheets, and audited permanent fund statements for the last three years.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>12.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિના છેવટની તારીખના કાચા સરવૈયાની નકલ તથા છેલ્લો ઓડિટ મેમો. (Copy of the latest provisional balance sheet and the most recent audit memo of the Market Committee.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>13.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                           જમીન/મિલકત વેચ્યા બાદ ઉપજેલ નાણાં બજાર સમિતિ યોગ્ય ધારાધોરણ/નિયમ મુજબ જ બજાર સમિતિને લાભકર્તા થાય તે રીતે જ ઉપયોગમાં લેશે તેની બાંહેધરી. (Undertaking that the funds generated from the sale will be used in a manner beneficial to the Market Committee and strictly as per applicable norms/rules.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>14.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            ઉપર્યુક્ત તમામ બાબતો સાંકળી લેતો સહકારી અધિકારી (બજાર)નો સ્થળ તપાસ અહેવાલ. (રોજકામ ફોટોગ્રાફ સહ) (Site inspection report by the Co-operative Officer (Market) covering all of the above aspects, along with work photographs.)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
 
                    <div className='d-flex border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>15.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>
                            બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (વર્ગ અ, બ, ક, ડ) (Income-based classification certificate of the Market Committee (Category A, B, C, or D).)
                        </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                        <input 
                            className='form-control w-75' type='file' 
                            name="copyOfMarketCommitteEstDet" 
                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                            id='uploadPlan'>
                        </input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="d-flex p-5 justify-content-end">
            <button className="btn px-4 btn-info">Submit</button>
        </div>
        </div>
    </>
  )
}

export default SellApmc